"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_options-menu.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var OptionsMenu = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.toggleMenu = function () {
      var a = d.props.setIconLabelsVisibility;
      d.setState(function (a) {
        var b = a.menuOpen;
        return {
          menuOpen: !b
        };
      }, function () {
        var b = d.state.menuOpen;
        return a(!b), b ? void document.addEventListener("mousedown", d.handleClick) : void document.removeEventListener("mousedown", d.handleClick);
      });
    }, d.handleClick = function (a) {
      var b = d.state.menuOpen;
      d._menuRef.contains(a.target) || !b || d.toggleMenu();
    }, d.state = {
      menuOpen: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClick);
    }
  }, {
    key: "render",
    value: function render() {
      var a = this,
          b = this.props,
          c = b.options,
          d = b.selectedIndex,
          e = b.children,
          f = b.disabled,
          g = this.state.menuOpen;
      return !f && c && c.length ? _react["default"].createElement("div", {
        ref: function ref(b) {
          a._menuRef = b;
        },
        className: "player-options-menu"
      }, _react["default"].cloneElement(e, {
        onClick: this.toggleMenu
      }), g ? _react["default"].createElement("div", {
        className: "player-options-menu__inner"
      }, c.map(function (a, b) {
        return _react["default"].createElement("button", {
          key: a.label,
          type: "button",
          className: "player-options-menu__option",
          onClick: a.onClick
        }, _react["default"].createElement("p", null, a.label, a.superscript ? _react["default"].createElement("sup", null, a.superscript) : null), d === b ? _react["default"].createElement(_uiKit.Icon, {
          name: "success",
          color: "white",
          size: 10
        }) : null);
      })) : null) : e;
    }
  }]), b;
}(_react.Component);

exports["default"] = OptionsMenu;